function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M18 3H6v4h12V3zM3 10a2 2 0 012-2h14a2 2 0 012 2v7h-3v4H6v-4H3v-7zm13 4H8v5h8v-5zm3-3a1 1 0 11-2 0 1 1 0 012 0z",
  fill: "currentColor"
});

function SvgPrint(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    ref: svgRef
  }, props), _ref);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrint);
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xOCAzSDZWN0gxOFYzWk0zIDEwQzMgOC44OTU0MyAzLjg5NTQzIDggNSA4SDE5QzIwLjEwNDYgOCAyMSA4Ljg5NTQzIDIxIDEwVjE3SDE4VjIxSDZWMTdIM1YxMFpNMTYgMTRIOFYxOUgxNlYxNFpNMTkgMTFDMTkgMTEuNTUyMyAxOC41NTIzIDEyIDE4IDEyQzE3LjQ0NzcgMTIgMTcgMTEuNTUyMyAxNyAxMUMxNyAxMC40NDc3IDE3LjQ0NzcgMTAgMTggMTBDMTguNTUyMyAxMCAxOSAxMC40NDc3IDE5IDExWiIgZmlsbD0iY3VycmVudENvbG9yIi8+Cjwvc3ZnPgo=";
export { ForwardRef as ReactComponent };